import React from "react";
import BookingButtonPresenterTabContent from "./BookingButtonPresenterTabContent";
import Tabs from '../Tabs/Tabs';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class BookingButtonPresenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active_tab: 'general',
      loading: false,
      ...this.props
    };
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  };

  componentDidMount() {
    var self = this
    $(window).on("bookingButtonSaved", function () {
      $.ajax({
        type: 'POST',
        url: '/admin/booking_button_appearance/data',
      }).done((data) => {
        self.setState({...data})
      })
    });
  };

  render(){
    return (
      <div className="booking-button-builder-sidebar">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <BookingButtonPresenterTabContent {...this.props} {...this.state} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  tabs(){
    return(
      this.props.revert === true
      ?
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
      :
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('session_timeout'),
          targetName: 'session_timeout',
          classes: this.state.active_tab === 'session_timeout' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('menu'),
          targetName: 'menu',
          classes: this.state.active_tab === 'menu' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('form'),
          targetName: 'form',
          classes: this.state.active_tab === 'form' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('room_type_order'),
          targetName: 'room_type_order',
          classes: this.state.active_tab === 'room_type_order' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('no_availability'),
          targetName: 'no_availability',
          classes: this.state.active_tab === 'no_availability' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('installation_instructions'),
          targetName: 'installation',
          classes: this.state.active_tab === 'installation' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('history'),
          targetName: 'history',
          classes: this.state.active_tab === 'history' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab
    });
  };

};

export default BookingButtonPresenter